import { useEffect, useState } from 'react';

import { MarketingFooter, MarketingHeader } from '../components/MarketingChrome';
import { RequestAccessModal } from '../components/RequestAccessModal';

function MemoryPreview() {
  return (
    <div className="r42-company-memory" aria-label="Simplified Route42 Machine Memory preview">
      <div className="r42-company-memory-topline">
        <div><span>Machine Intelligence</span><strong>Machine Memory</strong></div>
        <span className="r42-company-memory-version">Version 42</span>
      </div>
      <section className="r42-company-memory-assessment">
        <span className="r42-company-memory-label">Current assessment</span>
        <h2>What Route42 currently understands</h2>
        <p>Route42 has connected the machine’s maintenance history, operating context, documented procedures, and unresolved questions into a persistent evidence-backed understanding.</p>
        <p>New information does not replace that history. It changes the memory, preserves what was learned, and makes conflicts visible.</p>
      </section>
      <div className="r42-company-memory-grid">
        <div><strong>25</strong><span>Documents</span></div>
        <div><strong>135</strong><span>Facts</span></div>
        <div><strong>51</strong><span>Knowledge Chunks</span></div>
        <div><strong>1</strong><span>Conflict</span></div>
      </div>
      <div className="r42-company-memory-attention">
        <span>Attention</span>
        <p><strong>2</strong> open investigations</p>
        <p><strong>1</strong> conflict requires review</p>
      </div>
    </div>
  );
}

export function CompanyPage() {
  const [requestOpen, setRequestOpen] = useState(false);

  useEffect(() => {
    const previousTitle = document.title;
    document.title = 'Company | Route42 Machine Intelligence';
    return () => { document.title = previousTitle; };
  }, []);

  return (
    <main className="r42-marketing-page r42-company-page">
      <MarketingHeader onRequestAccess={() => setRequestOpen(true)} />
      <section className="r42-company-hero">
        <div className="r42-company-grid">
          <div className="r42-company-copy">
            <span className="r42-marketing-eyebrow">Company</span>
            <h1>Industrial knowledge should compound, not disappear.</h1>
            <p>
              Route42 is committed to making industrial knowledge durable, explainable, and usable by the people responsible for machines. We believe intelligence should not be trapped in documents, fragmented across systems, or lost between shifts, facilities, and teams. Route42 exists to turn that fragmented history into a persistent Machine Intelligence layer that people can question, investigate, and build upon.
            </p>
            <div className="r42-company-vision">
              <span>Our vision</span>
              <strong>Make Machine Intelligence the new operating layer for industrial equipment—moving the center of gravity from recording work to understanding the machine itself.</strong>
            </div>
            <button className="r42-marketing-primary" type="button" onClick={() => setRequestOpen(true)}>Request access <i className="bi bi-arrow-right" aria-hidden="true" /></button>
          </div>
          <MemoryPreview />
        </div>
        <div className="r42-marketing-intelligence-line r42-company-line" aria-hidden="true"><span /></div>
      </section>
      <MarketingFooter />
      <RequestAccessModal open={requestOpen} onClose={() => setRequestOpen(false)} />
    </main>
  );
}
